/** @format */
import React, { FunctionComponent, useState } from 'react'
import { Dialog } from 'kpc-react'
interface OwnProps {
  children?: any
  onOk?: () => void
  content?: any
}
const DeleteConfirm: FunctionComponent<OwnProps> = ({ children, onOk, content }) => {
  const [show, setShow] = useState(false)
  return (
    <>
      <Dialog
        value={show}
        onOk={onOk}
        on$change-value={(c, show) => {
          setShow(show)
        }}
      >
        {content}
      </Dialog>
      <div
        onClick={e => {
          e.preventDefault()
          setShow(true)
        }}
      >
        {children}
      </div>
    </>
  )
}

export default DeleteConfirm
